import { render, staticRenderFns } from "./InternshipTechnology.vue?vue&type=template&id=4a2adcb4&scoped=true"
import script from "./InternshipTechnology.vue?vue&type=script&lang=js"
export * from "./InternshipTechnology.vue?vue&type=script&lang=js"
import style0 from "./InternshipTechnology.vue?vue&type=style&index=0&id=4a2adcb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2adcb4",
  null
  
)

export default component.exports